export default {
  about: "About",
  aboutUs: "About Us",
  contact: "Contact",
  careers: "Careers",
  legal: "Legal",
  privacy: "Privacy Policy",
  terms: "Terms of Service",
  cookies: "Cookie Policy",
  social: "Social",
  language: "Language",
  rights: "All rights reserved.",
  changed: "Language Changed",
  changedDescription: "The language has been changed successfully"
};